import { config } from 'vuex-module-decorators';
// set rawError to true by default on all @Action decorators
// see (https://github.com/championswimmer/vuex-module-decorators/pull/252)
config.rawError = true;
